import React from 'react';

export default function Button({onClick, children, className,width,size}) {
    return (
        <button className={`button ${className}`} onClick={onClick} id="join-button" style={{width: `${width}%`,fontSize:`${size}rem`}}>
            {children}
        </button>
    );
}
